const Error = () => {
return (
    <div>
        <h1>404 error no page found!</h1>
    </div>
)
}

export default Error